import { useContext } from "react";
import { TestRegistryContext } from "../store/testRegistryContext";
import { useFormContext } from "react-hook-form";

export const MinCorrectAnswersCount = () => {
  const { state } = useContext(TestRegistryContext);

  const questionsID = state.test.QuestionsID;

  const { register } = useFormContext();

  return (
    <div>
      <p className="my-[10px] text-black text-base font-normal">Необходимое количество правильных ответов для успешного прохождения теста</p>
      <select
        {...register("MinCorrectAnswersCount", { required: true })}
        defaultValue={+state.minCorrectAnswersCount}
        className="w-full rounded-md shadow-custom mb-5 border-[#DFE4EA] focus:border-[#DFE4EA]"
      >
        {questionsID.map((question, index) => (
          <option key={question} value={index + 1}>
            {index + 1}
          </option>
        ))}
      </select>
    </div>
  );
};
